import React from 'react';
import { connect } from 'react-redux';
import Paper from 'material-ui/Paper';
import More from './more';
import Qty from './qty';
import OrderProps from './order-props';
import ItemMore from './item-more';
import RequestedDelivDate from './requested-deliv-date';
import { requestSetPictures, requestSetDescrPdf } from './../../../../../actions/sets';
import IconButton from 'material-ui/IconButton';
import IconPayment from 'material-ui/svg-icons/action/euro-symbol';

const OrderRow = props => {
  const { order, order: { id }, rowsState, accessories, sets, toggleRowState, togglePaymentConditions, isRef, dispatch } = props;
  const styles = OrderRow.prepareStyles(isRef);
  const {
    rowStyle,
    orderStatusOffer,
    orderStatusProcessing,
    rowInnerStyle,
    firstColStyle,
    descrContainerStyle,
    descrStyle,
    commentStyle,
    qtyStyle,
    requestedDelivDateStyle,
    boldStyle,
    iconButtonStyle,
    iconStyle
  } = styles;

  const getOrderDescrJsx = order => {
    const firstKey = Object.keys(order.requested)[0];
    switch (order.type) {
      case 'a':
        return accessories[firstKey].descr;
      case 'm':
        return (
          <span>
            <span
              style={boldStyle}
            >
              {`${sets[firstKey].title}: `}
            </span>
            <span>
              {`${sets[firstKey].descr}`}
            </span>
          </span>) ;
      default:
        return '';
    }
  }

  return (
    <Paper className='preorderRow' key={id} style={rowStyle} zDepth={isRef ? 0 : 1} rounded={!isRef} >
      {order.status === 0 &&
        <div style={orderStatusProcessing}>
          <span style={{cursor: 'pointer'}}>
            Обрабатывается
          </span>
        </div>
      }
      {order.status === 1 &&
        <div style={orderStatusOffer}>
          <span style={{cursor: 'pointer'}}>
            Коммерческое предложение
          </span>
        </div>
      }
      <div className='preorderRowInner' style={rowInnerStyle}>
        <div className='orderMainProps' style={firstColStyle}>
          <OrderProps order={order} />
        </div>
        <div className='descrContainer' style={descrContainerStyle}>
          <div
            style={descrStyle}
            onClick={
              () => {
                if (order.type === 'm') {
                  dispatch({ type: 'SET_SET', p: Object.keys(order.requested)[0] });
                  dispatch({ type: 'SET_SCREEN', name: 'setCard', val: true });
                  dispatch(requestSetPictures());
                  dispatch(requestSetDescrPdf());
                };
              }
            }
          >
            {getOrderDescrJsx(order)}
          </div>
          <div style={qtyStyle}>
            <Qty order={order} />
          </div>
          <More order={order} toggleRowState={toggleRowState} rowsState={rowsState} />
          <div style={requestedDelivDateStyle}>
            <RequestedDelivDate order={order} />
          </div>
          {!isRef &&
            <div style={{marginRight: '12px'}}>
              <IconButton
                style={iconButtonStyle}
                iconStyle={iconStyle}
                onClick={
                  () => {
                    togglePaymentConditions(order.id);
                  }
                }
              >
                <IconPayment />
              </IconButton>
            </div>
          }
          <div style={commentStyle}>
            {order.comment}
          </div>
        </div>
      </div>
      {rowsState[id] &&
        <div>
          <div>
            { Object.keys(order.requested).map( (key, i) => {
              if (i === 0) {
                return null;
              }
                return <ItemMore key={key} propKey={key} {...props} />;
            }) }
          </div>
        </div>
      }
    </Paper>
  )
}

OrderRow.defaultProps = {
  isRef: false
}

export default connect()(OrderRow);

OrderRow.prepareStyles = isRef => {
  return {
    rowStyle: {
      display: 'flex',
      flex: '1 0 auto',
      flexDirection: 'column',
      padding: '4px',
      paddingLeft: '12px',
      marginBottom: '12px',
      position: 'relative',
      border: '1px solid #ddd',
      background: isRef ? '#eee' : '#fff',
      marginLeft: isRef ? '-12px' : '0px',
      marginTop: isRef ? '-4px' : '0px',
      marginRight: isRef ? '-4px' : '0px',
    },
    rowInnerStyle: {
      display: 'flex',
      flex: '1 0 auto',
      alignItems: 'center',
      position: 'relative',
      height: '64px',
    },
    firstColStyle: {
      display: 'flex',
      flexDirection: 'column',
      flex: '0 0 150px',
      fontSize: '12px'
    },
    descrContainerStyle: {
      display: 'flex',
      alignItems: 'center',
      maxWidth: '500px'
    },
    descrStyle: {
      display: 'flex',
      flex: '0 0 500px',
      color: '#3f51b5',
      cursor: 'pointer'
    },
    commentStyle: {
      display: 'flex',
      color: '#555',
      fontSize: '12px',
      flex: '1 1 200px',
    },
    qtyStyle: {
      display: 'flex',
      flex: '0 0 50px',
      fontWeight: 'bold',
    },
    requestedDelivDateStyle: {
      display: 'flex',
      flex: '0 0 150px',
    },
    boldStyle: {
      fontWeight: 'bold'
    },
    orderStatusProcessing: {
      position: 'absolute',
      right: '0px',
      top: '0px',
      // border: '1px solid #555',
      fontSize: '10px',
      color: '#555',
      borderRadius: '10px',
      padding: '6px',
      display: 'flex',
      cursor: 'pointer',
      fontWeight: 'bold'
    },
    iconButtonStyle: {
      // display: 'flex',
      // flex: '0 0 30px',
      padding: '4px',
      height: '32px',
      width: '32px'
    },
    iconStyle: {
      // padding: '0px',
      // height: '24px',
      // width: '24px'
    },
  }
}



// WEBPACK FOOTER //
// ./src/components/layout/content/orders/order-row-preorder/index.js